// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

    });

export function text81_mouseIn(event) {

	$w('#text85').show();
    $w('#image47').show();
    $w('#text81').hide();
    $w('#image44').hide();
}

export function text85_click(event) {
	$w('#text85').hide();
    $w('#image47').hide();
    $w('#text81').show();
    $w('#image44').show(); 
}

export function text85_mouseOut(event) {
    $w('#text85').hide();
    $w('#image47').hide();
    $w('#text81').show();
    $w('#image44').show();
}